import { render, staticRenderFns } from "./StepOTP.vue?vue&type=template&id=2e520e91"
import script from "./StepOTP.vue?vue&type=script&lang=js"
export * from "./StepOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports